import { getUnreadMessages } from '../../services/getUnreadMessages';
import { EUnreadMessagesStatus } from '../../types/messages';
import { TThunkAction } from '../../types/redux';
import { actionGenerator } from '../../utils/redux/actionGenerator';
import { isSameAuthenticatedSession } from '../../utils/userSession';
import { EMessagesActionTypes, ILoadedUnreadMessagesPayload, IUnreadMessagesRequestPayload } from './types';

let nextRequestId = 0;

export const loadingUnreadMessages = actionGenerator<
  EMessagesActionTypes.LoadingUnreadMessages,
  IUnreadMessagesRequestPayload
>(EMessagesActionTypes.LoadingUnreadMessages);
export const loadedUnreadMessages = actionGenerator<
  EMessagesActionTypes.LoadedUnreadMessages,
  ILoadedUnreadMessagesPayload
>(EMessagesActionTypes.LoadedUnreadMessages);
export const failedUnreadMessages = actionGenerator<
  EMessagesActionTypes.FailedUnreadMessages,
  IUnreadMessagesRequestPayload
>(EMessagesActionTypes.FailedUnreadMessages);
export const resetUnreadMessages = actionGenerator<EMessagesActionTypes.ResetUnreadMessages>(
  EMessagesActionTypes.ResetUnreadMessages,
);

interface ILoadUnreadMessagesOptions {
  force?: boolean;
}

export const loadUnreadMessages =
  ({ force = false }: ILoadUnreadMessagesOptions = {}): TThunkAction<Promise<void>> =>
  async (dispatch, getState, context) => {
    const { messages, user } = getState();

    if (
      !user.isAuthenticated ||
      messages.status === EUnreadMessagesStatus.Loading ||
      (!force && messages.status === EUnreadMessagesStatus.Succeed)
    ) {
      return;
    }

    const requestedUser = user;
    const requestId = ++nextRequestId;
    dispatch(loadingUnreadMessages({ requestId }));

    try {
      const count = await getUnreadMessages(context, true);
      const currentUser = getState().user;

      if (!isSameAuthenticatedSession(requestedUser, currentUser)) {
        return;
      }

      dispatch(loadedUnreadMessages({ count, requestId }));
    } catch (error) {
      context.logger.warning(error, {
        domain: 'loadUnreadMessages',
        message: 'Failed load unread messages',
      });

      if (isSameAuthenticatedSession(requestedUser, getState().user)) {
        dispatch(failedUnreadMessages({ requestId }));
      }
    }
  };
